let stripe
let paymentRequest
let paymentRequestButton

export default {
  name: 'stripe-button',
  props: {
    stripe: Object,
    country: String,
    currency: String,
    total: Number,
    displayItems: Array,
    shippingOptions: Array
  },
  beforeMount () {
    // Stripe exists as the Stripe library is included in index.html.
    /* eslint-disable no-undef */
    stripe = Stripe(process.env.STRIPE_SECRET_KEY)
    paymentRequest = stripe.paymentRequest({
      country: this.country,
      currency: this.currency,
      total: {
        label: 'Total', // @todo Translate.
        amount: this.total
      },
      displayItems: this.displayItems,
      shippingOptions: this.shippingOptions,
      requestPayerName: false,
      requestPayerEmail: false,
      requestPayerPhone: false,
      requestShipping: false
    })
    paymentRequest.on('source', function (event) {
      try {
        this.$emit('event', event)
        event.complete('success')
      } catch (error) {
        event.complete('fail')
      }
    })
  },
  mounted () {
    // @todo Stripe elements 'locale' doesn't work, hard-coding to Swedish to avoid different behavior in production.
    paymentRequestButton = stripe.elements({ locale: 'sv' }).create('paymentRequestButton', { paymentRequest })
    paymentRequest.canMakePayment().then(function (result) {
      if (result) {
        paymentRequestButton.mount('#payment-request-button')
      } else {
        document.getElementById('payment-request-button').style.display = 'none'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/stripe-button/script.js